import {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {OnboardingLayout} from './OnboardingLayout';
import {Button, ProgressBar} from '@/components';
import {useUserStore} from '@/store';
import styles from './Onboarding.module.css';

export function Syncing() {
  const navigate = useNavigate();
  const {syncStatus, syncProgress, syncItemCount, completeOnboarding, pollSyncProgress} =
    useUserStore();

  const isDone = syncStatus === 'done';
  const isError = syncStatus === 'error';

  // If we arrive here and sync hasn't started polling yet, kick it off
  useEffect(() => {
    if (syncStatus === 'syncing') {
      pollSyncProgress();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function handleLaunch() {
    completeOnboarding();
    navigate('/closet');
  }

  function handlePreview() {
    completeOnboarding();
    navigate('/closet');
  }

  return (
    <OnboardingLayout currentStep={4} totalSteps={4}>
      <h2 className={styles.stepTitle}>Syncing your purchases</h2>
      <div className={styles.syncWrap}>
        <div
          className={[styles.syncRing, isDone ? styles.syncRingDone : '']
            .filter(Boolean)
            .join(' ')}
        />
        <div className={styles.syncCount}>{syncItemCount}</div>
        <div className={styles.syncSub}>
          {isError ? 'Something went wrong' : 'items found so far...'}
        </div>
        <div className={styles.syncProgress}>
          <ProgressBar
            percent={syncProgress}
            label={
              isDone
                ? 'Sync complete!'
                : isError
                  ? 'Sync failed — you can still preview your closet'
                  : `Scanning receipts... ${syncProgress}%`
            }
          />
        </div>
      </div>
      <div className={styles.syncBtns}>
        <Button disabled={!isDone && !isError} onClick={handleLaunch}>
          {isDone ? "Let's Go" : isError ? 'Continue Anyway' : 'Waiting...'}
        </Button>
        {!isDone && !isError && (
          <Button variant="secondary" onClick={handlePreview}>
            Start Previewing Closet
          </Button>
        )}
      </div>
    </OnboardingLayout>
  );
}
